<ag-grid-angular
  class="ag-theme-alpine"
  [gridOptions]="agrigatedGridOptions"
  [rowData]="data"
  [quickFilterText]="searchText"
  [domLayout]="domLayout"
>
</ag-grid-angular>
